import styled from "@emotion/styled";
import tw from "twin.macro";

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
    background-color: #F8F9FF;
`;
